export class ThymeError extends Error {
  constructor(message: string) {
    super(message)
    this.name = this.constructor.name
  }

  static fromError<T extends ThymeError>(
    this: new (message: string) => T,
    error: unknown
  ): T {
    if (error instanceof Error) {
      return new this(error.message)
    } else if (typeof error === 'string') {
      return new this(error)
    } else {
      return new this('An unknown error occurred')
    }
  }
}

export class ThymeEventError extends ThymeError {}
export class ThymeAuth0Error extends ThymeError {}
